var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.49984C7.5 2.0396 7.8731 1.6665 8.33333 1.6665H11.6667C12.1269 1.6665 12.5 2.0396 12.5 2.49984V3.33317H16.6667C17.1269 3.33317 17.5 3.70627 17.5 4.1665C17.5 4.62674 17.1269 4.99984 16.6667 4.99984H3.33333C2.8731 4.99984 2.5 4.62674 2.5 4.1665C2.5 3.70627 2.8731 3.33317 3.33333 3.33317H7.5V2.49984Z",
    fill: "#231546"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 6.6665H5C4.53976 6.6665 4.16667 7.0396 4.16667 7.49984V15.8332C4.16667 17.2139 5.28595 18.3332 6.66667 18.3332H13.3333C14.714 18.3332 15.8333 17.2139 15.8333 15.8332V7.49984C15.8333 7.0396 15.4602 6.6665 15 6.6665ZM8.33333 8.33317C7.8731 8.33317 7.5 8.70627 7.5 9.1665V14.1665C7.5 14.6267 7.8731 14.9998 8.33333 14.9998C8.79357 14.9998 9.16667 14.6267 9.16667 14.1665V9.1665C9.16667 8.70627 8.79357 8.33317 8.33333 8.33317ZM10.8333 9.1665C10.8333 8.70627 11.2064 8.33317 11.6667 8.33317C12.1269 8.33317 12.5 8.70627 12.5 9.1665V14.1665C12.5 14.6267 12.1269 14.9998 11.6667 14.9998C11.2064 14.9998 10.8333 14.6267 10.8333 14.1665V9.1665Z",
    fill: "#231546"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.e8d080ef8556f275569fe4c4d6df37fd.svg";
export { ForwardRef as ReactComponent };